import React from "react";
import "./btn-blanc-left.scss";
import PropTypes from "prop-types";

/**
 * Permet d'afficher les boutons blancs avec l'icône avant le texte
 */
const BtnBlanc = (props) => {
  return (
    <button
      className="btn-blanc left"
      onClick={props.btnAction}
      type={props.action}
    >
      {props.children}
      {props.btnTexte}
    </button>
  );
};

BtnBlanc.propTypes = {
  action: PropTypes.string,
  btnAction: PropTypes.func,
  btnTexte: PropTypes.string,
  children: PropTypes.any,
};

BtnBlanc.defaultProps = {
  action: "submit",
};

export default BtnBlanc;
